<template>
	<component
		:is="outerTag"
		class="card card--no-gutter news-list-item list-item grid-noGutter"
		:class="{ 'list-item--mounted': isMounted }"
		:href="data.link"
	>
		<span class="news-list-item_icon" v-html="IconDocument"></span>
		<div
			v-if="!showPattern"
			class="news-list-item__image"
			v-html="data.image"
		></div>
		<div
			v-if="showPattern"
			class="news-list-item__pattern"
			v-html="Pattern"
		></div>
		<div class="news-list-item__copy">
			<p
				class="news-list-item__date"
				:aria-describedby="'news-title__' + data.id"
			>
				{{
					sameDate
						? formatDateNoLeadingZeros(data.startDate, false, true)
						: formatDateTimeNoLeadingZeros(
								data.startDate,
								at,
								true,
								true
						  )
				}}
				{{
					data.endDate && data.endDate != "0001-01-01T00:00:00"
						? sameDate == true
							? at +
							  " " +
							  parseInt(
									(
										"0" +
										new Date(data.startDate).getHours()
									).slice(-2)
							  ) +
							  "-" +
							  parseInt(
									(
										"0" + new Date(data.endDate).getHours()
									).slice(-2)
							  )
							: " " +
							  (textTo != "" ? textTo : "-") +
							  " " +
							  formatDateTimeNoLeadingZeros(
									data.endDate,
									at,
									true,
									true
							  )
						: ""
				}}
			</p>
			<h3
				class="news-list-item__title header-extra-small"
				:id="'news-title__' + data.id"
			>
				{{ data.title }}
			</h3>
			<span class="news-list-item__description body-text-small">
				{{ data.description }}
			</span>
		</div>
	</component>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import IconDocument from "../../../../views/icons/document.cshtml";
import Pattern from "../../../../views/visuals/leafPatternLarge.cshtml";
import {
	formatDateNoLeadingZeros,
	formatDateTimeNoLeadingZeros
} from "../../../shared/script/utilities";

const props = defineProps(['data', 'at', 'textTo']);
const isMounted = ref(false);
const outerTag = ref(props.data.disableLink !== true ? 'a' : 'div');

onMounted(() => {
	setTimeout(() => {
		isMounted.value = true;
	}, 10);
});

const showPattern = computed(() => {
	return props.data.image.length == 0;
});

const sameDate = computed(() => {
	const date1 = new Date(props.data.startDate);
	const date2 = new Date(props.data.endDate);
	return (
		date1 &&
		date2 &&
		date1.getDate() == date2.getDate() &&
		date1.getMonth() == date2.getMonth() &&
		date1.getFullYear() == date2.getFullYear()
	);
});
</script>
